import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=3b6f7ca0&scoped=true"
import script from "./ArticlePreview.vue?vue&type=script&lang=js"
export * from "./ArticlePreview.vue?vue&type=script&lang=js"
import style0 from "./ArticlePreview.vue?vue&type=style&index=0&id=3b6f7ca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6f7ca0",
  null
  
)

export default component.exports